<template>
  <div class="header FTG-Menu">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="dark" active-name="2">
          <div class="headerTitle SelectNone">
            FTG | DELIVER THE EXCELLENCE
          </div>
          <div class="layout-nav SelectNone">
            <MenuItem :to="{path: '/'}" name="2">Works</MenuItem>
            <MenuItem :to="{path: '/about'}" name="3">About</MenuItem>
            <MenuItem :to="{path: '/contact'}" name="4">Contact</MenuItem>
            <div class="Clear"></div>
          </div>
          <Icon @click="showMenu()" class="HeaderMenu" type="md-menu" />
        </Menu>
      </Header>
    </Layout>

    <!-- menu -->
    <Modal v-model="menuModal" class="MenuModal" :styles="{top: '0px'}">
      <Collapse simple>
        <Panel name="1">
          Works
          <div slot="content">
            <Button @click="toImgs('all')" type="text">All</Button>
            <Button @click="toImgs('a')" type="text">Still Image</Button>
            <Button @click="toImgs('b')" type="text">Animation</Button>
            <Button @click="toImgs('c')" type="text">VR | AR</Button>
          </div>
        </Panel>
      </Collapse>
      <Button @click.native="toPage('/about')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">About</Button>
      <Button @click.native="toPage('/contact')" class="singalBtn" type="text">Contact</Button>
    </Modal>


  </div>
</template>

<script>
export default {
  name: 'NavHeader',
  data () {
    return {
      menuModal: false
    }
  },
  methods: {
    showMenu(){
      this.menuModal = true
    },
    toImgs(str){
      document.documentElement.scrollTop = window.innerHeight
      this.menuModal = false

      if(str == 'a'){                    // Still Image
        eventBus.$emit('still');
      }else if(str == 'b'){              // Animation
        eventBus.$emit('animat');
      }else if(str == 'c'){              // VR | AR
        eventBus.$emit('arvr');
      }else{                             // All
        eventBus.$emit('alls');
      }
    },
    toPage(_path){
      this.$router.push({path: _path})
    }
  },
  mounted() {

  },
  watch:{
    
  }
}
</script>

<style scoped lang="less">
  @import './component.less';
</style>



// WEBPACK FOOTER //
// src/components/mainHeader.vue